import axios from "./axios-auth";

const getCart = (offset, limit) =>
  new Promise((resolve, reject) => {
    const params = {
      offset: offset,
      limit: limit,
    };
    axios({
      url: "/me/cart",
      method: "GET",
      params: params,
    })
      .then((resp) => {
        resolve(resp.data.items);
      })
      .catch((err) => {
        reject(err);
      });
  });

const putInCart = async (productVersionId, quantity, categoryID) => {
  const cartItem = {
    productVersionId: productVersionId,
    quantity: quantity,
    categoryID, categoryID
  };

  try {
  const resp = await axios({
    url: "/me/cart",
    data: cartItem,
    method: "PUT",
  })

  return resp.date;
}
catch (e) {
  console.error(e)
  throw e;
}

}
const patchInCart = (cartItemId, productVersionId, quantity) =>
  new Promise((resolve, reject) => {
    const cartItem = {
      productVersionId: productVersionId,
      quantity: quantity,
    };
    axios({
      url: "/me/cart/" + cartItemId,
      data: cartItem,
      method: "PUT",
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

const removeFromCart = (cartItemId) =>
  new Promise((resolve, reject) => {
    axios({
      url: "/me/cart/" + cartItemId,
      method: "DELETE",
    })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

const validateCart = (payTaxes) =>
  new Promise((resolve, reject) => {
    const data = {
      usePointsToPayTaxes: payTaxes,
    };
    axios({
      url: "/me/cart/validate",
      data: data,
      method: "POST",
    })
      .then((resp) => {
        const response = {
          isCartValid: resp.data.isCartValid,
          errorsArray: resp.data.errors,
        };
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  });

const orderCart = (payTaxes, orderEmail) =>
  new Promise((resolve, reject) => {
    const data = {
      usePointsToPayTaxes: payTaxes,
      orderEmailAddress: orderEmail,
      platform: "Desktop",
      platformversion: "1.7.5",
    };
    axios({
      url: "/me/cart/order",
      data: data,
      method: "POST",
    })
      .then((resp) => {
        const response = {
          isCartValid: resp.data.isCartValid,
          errorsArray: resp.data.errors,
          physicalProducts: resp.data.physicalProducts,
          digitalGiftCards: resp.data.digitalGiftCards,
        };
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  });

const getCartSummary = () =>
  new Promise((resolve, reject) => {
    axios({
      url: "/me/cart/summary",
      method: "GET",
    })
      .then((resp) => {
        const summary = {
          items: resp.data.items,
          productPoints: resp.data.productPoints,
          taxPoints: resp.data.taxPoints,
        };
        resolve(summary);
      })
      .catch((err) => {
        reject(err);
      });
  });

const getCartUnapproved = () =>
  new Promise((resolve, reject) => {
    axios({
      url: "/me/cart/unapproved",
      method: "GET",
    })
      .then((resp) => {
        const summary = {
          items: resp.data.items,
          productPoints: resp.data.productPoints,
          taxPoints: resp.data.taxPoints,
        };
        resolve(summary);
      })
      .catch((err) => {
        reject(err);
      });
  });

export {
  getCart,
  putInCart,
  removeFromCart,
  getCartSummary,
  patchInCart,
  validateCart,
  orderCart,
  getCartUnapproved,
};
